import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { Ilanding } from "../../../models/ilanding";

@Injectable({
  providedIn: "root",
})
export class LandingService {
  private Http = inject(HttpClient);

  getLanding() {
    return this.Http.get<Ilanding>(`${environment.apiUrl}api/website/home`);
  }
}
